import { PowerDealState } from './types'

export const state: PowerDealState = {
  list: [],
  sales: [],
  hourly: [],
  sku: [],
  collection: ''
}
